import Lara from "@/presets/lara";

export const priceOverrideTablePresets = {
  ...Lara,
  datatable: {
    ...Lara.datatable,
    thead: (args) => ({
      class: [...Lara.datatable.thead(args).class],
    }),
  },
  viewButton: {
    ...Lara.button,
    label: { class: ["uppercase", "text-base"] },
  },
  approvalButton: {
    ...Lara.button,
    label: { class: ["capitalized", "text-base", "font-normal", "text-surface-700"] },
    root: (args) => ({
      class: [...Lara.button.root(args).class, "!border-grey", "flex", "flex-row-reverse"],
    }),
  },
  bulkEditButton: {
    ...Lara.button,
    label: { class: ["capitalized", "text-sm", "font-semibold"] },
    root: (args) => ({
      class: [...Lara.button.root(args).class, "!ml-0"],
    }),
  },
  approvalMenu: {
    ...Lara.menu,
    submenuheader: {
      class: ["hidden"],
    },
  },
};
